<template>
  <div>
    <!-- <h2 class="text-center colorblue">Моя Организация</h2> -->
    <v-card>
      <v-tabs v-model="tab" centered>
        <v-tab v-for="item in items" :key="item">{{ item }}</v-tab>
      </v-tabs>
    </v-card>
    <v-card>
      <v-tabs-items v-model="tab" class="mt-2">
        <v-tab-item>
          <v-card-text>
            <MainInfo />
          </v-card-text>
        </v-tab-item>
        <v-tab-item>
          <v-card-text>
            <BankAccounts />
          </v-card-text>
        </v-tab-item>
        <v-tab-item v-if="!sz">
          <v-card-text>
            <UserAccounts />
          </v-card-text>
        </v-tab-item>
        <v-tab-item>
          <v-card-text>
            <API />
          </v-card-text>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import BankAccounts from "./orginfo/bankAccounts.vue";
import UserAccounts from "./orginfo/UserAccounts.vue";
import MainInfo from './orginfo/orgMainInfo.vue'
import API from './orginfo/API.vue';
import { roleObj } from '@/plugins/roles.js';
// import Swal from "sweetalert2";

export default {
  components: {
    BankAccounts,
    UserAccounts,
    MainInfo,
    API
  },
  data: () => ({
    tab: 0,
  }),
  computed: {
    items() {
      const main = ['Общая информация', 'Банковские реквизиты']
      const users = 'Мои сотрудники'
      const api = 'API'
      if (!this.sz) {
        main.push(users)
      }
      if (this.showApi) {
        main.push(api)
      }
      return main
    },
    sz() {
      const reg = /Самозанятый/g
      const name = this.$store.getters.getMyOrganisation.orgShortName
      return reg.test(name)
    },
    showApi() {
      return this.role() === roleObj.bankAdmin || this.role() === roleObj.agregatorAdmin ? false : true
    }
  },
  mounted() {
    this.setTitle('Моя Организация')
  },
  created() {
    if (this.role() === roleObj.users) {
      this.$router.push('/404')
    }
  }
}
</script>
